__turbopack_context__.v({
  "buttonContainer": "error-module__xlMtpW__buttonContainer",
  "container": "error-module__xlMtpW__container",
  "content": "error-module__xlMtpW__content",
  "description": "error-module__xlMtpW__description",
  "title": "error-module__xlMtpW__title",
});
